import { render, staticRenderFns } from "./SalesRevenueDetailDialog.vue?vue&type=template&id=2ecc67ea&scoped=true"
import script from "./SalesRevenueDetailDialog.vue?vue&type=script&lang=js"
export * from "./SalesRevenueDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc67ea",
  null
  
)

export default component.exports